
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'

import Breadcrumb from '@/components/Breadcrumb'
import { mapGetters } from 'vuex'
export default {
    components: {
        TitleBox,
        TitleBox2,
        Breadcrumb
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo'
        })
    },
    data() {
        return {
            loading: null,
            id: null, // 新闻公告、追回案例专用
            newDataTitle: '', // 新闻
            newDataTime: '', // 新闻

            // 显示第二个titleBox标题
            showDesc: false,
            leftImg: '',
            title: '', // 标题
            titleBoxTitle: '', // 第一个titleBox标题
            descTitle: '', // 第二个titleBox标题
            articleContent: '<p class="tc f18 text-aaa mt-115">加载中...</p>' // 内容
        }
    },
    head() {
        return {
            title: this.newDataTitle
        }
    },
    mounted() {
        // 黑号查询
        this.id = this.$route.params.id
        if (this.id) {
            this.getNewData(this.id)
        }
        console.log(this.$route.params, '详情')
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        getNewData(id) {
            let p = {
                action: {
                    id: parseInt(id)
                }
            }
            this.$api.listNewsDetail(p).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                let data = res.data
                if (data) {
                    this.titleBoxTitle = data.typeName === '普通' ? '最新公告' : data.typeName
                    this.articleContent = data.content
                    this.newDataTitle = data.title
                    this.newDataTime = data.createTime
                    return
                }
                this.articleContent = '<p class="tc f18 text-aaa mt-115">暂无内容</p>'
            })
        },
        getArticle() {
            let p = {
                action: {
                    title: this.title
                }
            }
            this.$api.articleDetail(p).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.articleContent = res.data ? res.data.content : '<p class="tc f18 text-aaa mt-115">暂无内容</p>'
            })
        }
    }
}
